import React, { useCallback, useState } from "react";
import { CardElement, Elements, EmbeddedCheckout, EmbeddedCheckoutProvider, PaymentElement, useCheckout, useElements, useStripe } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { strip_public_key } from "../../env";
import axios from "axios"; // this line is NOT valid

const validateEmail = async (email, checkout) => {
  const updateResult = await checkout.updateEmail(email);
  const isValid = updateResult.type !== "error";

  return { isValid, message: !isValid ? updateResult.error.message : null };
};

const EmailInput = ({ email, setEmail, error, setError }) => {
  const checkout = useCheckout();

  const handleBlur = async () => {
    if (!email) {
      return;
    }

    const { isValid, message } = await validateEmail(email, checkout);
    if (!isValid) {
      setError(message);
    }
  };

  const handleChange = (e) => {
    setError(null);
    setEmail(e.target.value);
  };

  return (
    <>
      <label>
        Email
        <input
          id="email"
          type="text"
          value={email}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="you@example.com"
        />
      </label>
      {error && <div id="email-errors">{error}</div>}
    </>
  );
};

// const CheckoutForm = () => {
//   const checkout = useCheckout();

//   const [email, setEmail] = useState("");
//   const [emailError, setEmailError] = useState(null);
//   const [message, setMessage] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     setIsLoading(true);

//     const { isValid, message } = await validateEmail(email, checkout);
//     if (!isValid) {
//       setEmailError(message);
//       setMessage(message);
//       setIsLoading(false);
//       return;
//     }

//     const { error } = await checkout.confirm();

//     // This point will only be reached if there is an immediate error when
//     // confirming the payment. Otherwise, your customer will be redirected to
//     // your `return_url`. For some payment methods like iDEAL, your customer will
//     // be redirected to an intermediate site first to authorize the payment, then
//     // redirected to the `return_url`.
//     setMessage(error.message);

//     setIsLoading(false);
//   };

//   return (
//     <form id="payment-form" onSubmit={handleSubmit}>
//       {/* <EmailInput
//         email={email}
//         setEmail={setEmail}
//         error={emailError}
//         setError={setEmailError}
//       /> */}
//       <h4>Payment</h4>
//       <PaymentElement id="payment-element" />
//       <button disabled={isLoading} id="submit">
//         <span id="button-text">
//           {isLoading ? (
//             <div className="spinner" id="spinner"></div>
//           ) : (
//             `Pay ${checkout.total.total.amount} now`
//           )}
//         </span>
//       </button>
//       {/* Show any error or success messages */}
//       {message && <div id="payment-message">{message}</div>}
//     </form>
//   );
// };


// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
// This test secret API key is a placeholder. Don't include personal details in requests with this key.
// To see your test secret API key embedded in code samples, sign in to your Stripe account.
// You can also find your test secret API key at https://dashboard.stripe.com/test/apikeys.
const stripePromise = loadStripe(strip_public_key);


const CheckoutForm = () => {
  const stripe = useStripe();
  const elements = useElements();

  const fetchClientSecret = useCallback(() => {
    // Create a Checkout Session
    return fetch(
      "https://3for3networking.com/backend/wp-content/plugins/wl-api/stripe-payment/create.php",
      {
        method: "POST",
      }
    )
      .then((res) => res.json())
      .then((data) => data.clientSecret);
  }, []);

  const options = { fetchClientSecret };

  // You can dynamically pull these from user data, state, etc.
  const [price, setPrice] = useState(1000); // e.g., $10 = 1000 cents
  const email = "user@example.com";
  const country = "IN";

  // const handleSubmit = async (event) => {
  //   event.preventDefault();

  //   console.log("Payment method call")

  //   if (!stripe || !elements) return;

  //   const cardElement = elements.getElement(CardElement);

  //   const { data } = await axios.post(
  //     "https://3for3networking.com/backend/wp-content/plugins/wl-api/stripe-payment/create.php",
  //     {
  //       price,
  //       email,
  //       country,
  //       type: "one-time", // or 'subscription'
  //     }
  //   );

  //   const clientSecret = data.clientSecret;

  //   // Create payment method
  //   const { error, paymentMethod } = await stripe.createPaymentMethod(
  //     clientSecret,
  //     {
  //       payment_method: {
  //         card: cardElement,
  //         billing_details: {
  //           email,
  //           address: { country },
  //         },
  //       },
  //     }
  //   );

  //   if (error) {
  //     console.error(error);
  //   } else {
  //     console.log("PaymentMethod:", paymentMethod);

  //     // Send to your PHP backend to create a PaymentIntent or Session
  //     const response = await axios.post(
  //       "https://3for3networking.com/backend/wp-content/plugins/wl-api/stripe-payment/create.php",
  //       {
  //         paymentMethodId: paymentMethod.id,
  //         email,
  //         country,
  //       }
  //     );

  //     const clientSecret = response.data.clientSecret;

  //     const result = await stripe.confirmCardPayment(clientSecret, {
  //       payment_method: paymentMethod.id,
  //     });

  //     if (result.error) {
  //       console.error(result.error.message);
  //     } else {
  //       alert("Payment successful!");
  //     }
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) return;

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: "http://localhost:3000/billing",
      },
    });

    if (error) {
      console.error(error.message);
      alert(error.message);
    }
  };

  return (
    <>
      {/* <div id="checkout">
      <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div> */}
      <form onSubmit={handleSubmit}>
        <div
          style={{
            padding: "0px",
            border: "0px solid #ccc",
            borderRadius: 4,
            marginBottom: 10,
          }}
        >
          <PaymentElement />
          <button
            type="submit"
            disabled={!stripe}
            style={{
              backgroundColor: "#5469d4",
              color: "#fff",
              border: "none",
              padding: "12px 16px",
              fontSize: "16px",
              borderRadius: 4,
              cursor: "pointer",
              width: "100%",
              marginTop: 10
            }}
          >
            Pay
          </button>
        </div>
      </form>
    </>
  );
};

export default CheckoutForm;
